import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'moss',
      d: 'M-3,-3h1.5v0.5h-1.5zM-4.5,-2.5h2.5v0.5h-2.5zM-1.5,-2.5h2v0.5h-2zM-5.5,-2h4.5v0.5h-4.5zM-0.5,-2h1v0.5h-1zM1.5,-2h1v0.5h-1zM-6.5,-1.5h0.5v0.5h-0.5zM-4.5,-1.5h3.5v1h-3.5zM1,-1.5h1.5v0.5h-1.5zM3,-1.5h0.5v0.5h-0.5zM-7,-1h1v0.5h-1zM1,-1h3.5v0.5h-3.5zM-7,-0.5h6v0.5h-6zM0,-0.5h4.5v0.5h-4.5zM6,-0.5h1v0.5h-1zM-6,0h2v0.5h-2zM-3,0h7v0.5h-7zM5.5,0h1.5v0.5h-1.5zM-5,0.5h0.5v0.5h-0.5zM-3,0.5h1.5v0.5h-1.5zM0.5,0.5h1v0.5h-1zM3.5,0.5h3v0.5h-3zM2,1h0.5v0.5h-0.5zM3,1h2.5v0.5h-2.5z',
    },
    {
      paint: 'tallGrass',
      d: 'M0.5,-3h0.5v0.5h-0.5zM-6.5,-2.5h0.5v0.5h-0.5zM-6.5,-2h1v0.5h-1zM-1,-2h0.5v0.5h-0.5zM-6,-1.5h1.5v1h-1.5zM-1,-1.5h2v1h-2zM2.5,-1.5h0.5v0.5h-0.5zM4.5,-1.5h0.5v0.5h-0.5zM5.5,-1.5h0.5v0.5h-0.5zM5.5,-1h1v0.5h-1zM-1,-0.5h1v0.5h-1zM4.5,-0.5h1.5v0.5h-1.5zM4,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'leaf',
      d: 'M-4.5,-4h1v1h-1zM-3,-4h0.5v0.5h-0.5zM-6,-3h0.5v1h-0.5zM-4.5,-3h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM2,-3h0.5v1h-0.5zM-5,-2.5h0.5v0.5h-0.5zM-2,-2.5h0.5v0.5h-0.5zM0.5,-2.5h0.5v1h-0.5zM4,-1.5h0.5v0.5h-0.5zM4.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M-3.5,-4.5h0.5v1h-0.5zM-3.5,-3.5h1v0.5h-1zM-5,-3h0.5v0.5h-0.5zM-4,-3h1v0.5h-1zM-1.5,-3h0.5v0.5h-0.5zM-0.5,-3h0.5v0.5h-0.5zM-5.5,-2.5h0.5v0.5h-0.5zM1,-2.5h1v0.5h-1zM1,-2h0.5v0.5h-0.5zM3.5,-1.5h0.5v0.5h-0.5zM5,-1.5h0.5v1h-0.5z',
    },
    {
      paint: 'flower',
      d: 'M-5.5,-5h1v0.5h-1zM0.5,-5h2v0.5h-2zM-6,-4.5h2v0.5h-2zM0,-4.5h3v1h-3zM-6,-4h1.5v1h-1.5zM0,-3.5h2.5v0.5h-2.5zM1,-3h1v0.5h-1z',
    },
    {
      paint: 'flowerCenter',
      d: 'M-3.5,-5.5h0.5v0.5h-0.5zM-1.5,-4h0.5v0.5h-0.5zM5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'wildflower',
      d: 'M-3,-7h0.5v0.5h-0.5zM-4.5,-6.5h2.5v0.5h-2.5zM-4.5,-6h1v1h-1zM-3,-6h1.5v1h-1.5zM-4.5,-5h2.5v0.5h-2.5zM-4,-4.5h0.5v0.5h-0.5zM-3,-4.5h0.5v0.5h-0.5zM3,-3.5h1v0.5h-1zM2.5,-3h2v1h-2zM2.5,-2h1.5v0.5h-1.5z',
    },
    {
      paint: 'flowerAlt',
      d: 'M-3.5,-6h0.5v0.5h-0.5zM-1.5,-5h0.5v0.5h-0.5zM-2.5,-4.5h2.5v0.5h-2.5zM-2.5,-4h1v0.5h-1zM-1,-4h1v0.5h-1zM-2.5,-3.5h2v0.5h-2zM4.5,-3h1.5v0.5h-1.5zM4.5,-2.5h0.5v0.5h-0.5zM5.5,-2.5h1v0.5h-1zM4,-2h2v0.5h-2z',
    },
    {
      paint: 'leafLight',
      d: 'M-4,0h1v0.5h-1zM-4.5,0.5h1.5v0.5h-1.5zM1.5,0.5h2v0.5h-2zM2.5,1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 289,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'moss',
      d: 'M-1.5,-3h0.5v0.5h-0.5zM1.5,-3h0.5v0.5h-0.5zM-2,-2.5h1v0.5h-1zM0,-2.5h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM-3.5,-2h2.5v0.5h-2.5zM1,-2h1v0.5h-1zM2.5,-2h0.5v0.5h-0.5zM-4,-1.5h3.5v1.5h-3.5zM1,-1.5h2v1h-2zM-6,-1h1v1.5h-1zM5,-1h0.5v0.5h-0.5zM1,-0.5h2.5v0.5h-2.5zM4.5,-0.5h1v1h-1zM-3,0h6.5v0.5h-6.5zM-3.5,0.5h5v0.5h-5zM3.5,0.5h1.5v0.5h-1.5zM1.5,1h1v0.5h-1zM3,1h1v0.5h-1z',
    },
    {
      paint: 'tallGrass',
      d: 'M0.5,-3.5h0.5v1.5h-0.5zM-5.5,-3h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM-5.5,-2.5h1v0.5h-1zM-4,-2.5h0.5v0.5h-0.5zM-1,-2.5h1v0.5h-1zM3,-2.5h0.5v1h-0.5zM4.5,-2.5h1v0.5h-1zM-5.5,-2h0.5v1h-0.5zM-4.5,-2h0.5v0.5h-0.5zM-1,-2h2v0.5h-2zM4,-2h1v0.5h-1zM-0.5,-1.5h1.5v1.5h-1.5zM3,-1.5h1v0.5h-1zM-5,-1h1v1.5h-1zM3,-1h2v0.5h-2zM3.5,-0.5h1v1h-1z',
    },
    {
      paint: 'leaf',
      d: 'M1,-4.5h0.5v0.5h-0.5zM-2.5,-4h0.5v1h-0.5zM-1.5,-4h1v0.5h-1zM0.5,-4h1v0.5h-1zM-1.5,-3.5h1.5v0.5h-1.5zM2,-3.5h0.5v0.5h-0.5zM3,-3.5h0.5v1h-0.5zM-3.5,-3h1v1h-1zM-0.5,-3h0.5v0.5h-0.5zM-4.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-5,-2h0.5v0.5h-0.5zM-4,-2h0.5v0.5h-0.5zM-5,-1.5h1v0.5h-1zM4,-1.5h1v0.5h-1z',
    },
    {
      paint: 'bushDark',
      d: 'M0,-5h0.5v0.5h-0.5zM1,-5h0.5v0.5h-0.5zM-1.5,-4.5h1v0.5h-1zM0,-4.5h1v0.5h-1zM-2,-4h0.5v1h-0.5zM0,-4h0.5v1.5h-0.5zM-3.5,-3.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v1h-0.5zM-2.5,-3h1v0.5h-1zM1,-3h0.5v0.5h-0.5zM-2.5,-2.5h0.5v0.5h-0.5zM2,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'flower',
      d: 'M2,-7h1v1h-1zM1.5,-6h2v0.5h-2zM-4.5,-5.5h0.5v0.5h-0.5zM1.5,-5.5h0.5v0.5h-0.5zM3,-5.5h0.5v0.5h-0.5zM-4.5,-5h1v0.5h-1zM1.5,-5h2v1h-2zM-5,-4.5h1.5v0.5h-1.5zM-5,-4h0.5v0.5h-0.5zM-4,-4h1v0.5h-1zM1.5,-4h1.5v0.5h-1.5zM-5,-3.5h1.5v1h-1.5z',
    },
    {
      paint: 'flowerCenter',
      d: 'M0,-7.5h0.5v0.5h-0.5zM-2.5,-6.5h0.5v0.5h-0.5zM2,-5.5h1v0.5h-1zM-4.5,-4h0.5v0.5h-0.5z',
    },
    {
      paint: 'wildflower',
      d: 'M-2.5,-8.5h0.5v0.5h-0.5zM-2.5,-8h1v1h-1zM-3,-7h2v0.5h-2zM-3,-6.5h0.5v0.5h-0.5zM-1.5,-6.5h0.5v1h-0.5zM-3.5,-6h1v0.5h-1zM-3,-5.5h2v0.5h-2zM-3.5,-5h2.5v0.5h-2.5zM-3.5,-4.5h2v0.5h-2zM3.5,-4h1v1h-1zM4.5,-3h0.5v0.5h-0.5zM3.5,-2.5h1v0.5h-1z',
    },
    {
      paint: 'flowerAlt',
      d: 'M0,-9.5h0.5v1h-0.5zM-0.5,-8.5h1.5v0.5h-1.5zM-1,-8h2.5v0.5h-2.5zM-1,-7.5h1v0.5h-1zM0.5,-7.5h0.5v0.5h-0.5zM-1,-7h2.5v1.5h-2.5zM-2,-6.5h0.5v0.5h-0.5zM-2.5,-6h1v0.5h-1zM-1,-5.5h2v0.5h-2zM3.5,-3h1v0.5h-1zM3.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-4,0h1v0.5h-1zM-5,0.5h1.5v0.5h-1.5zM1.5,0.5h2v0.5h-2zM2.5,1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 308,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'moss',
      d: 'M1,-3h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM-2.5,-2.5h1v0.5h-1zM1.5,-2.5h1v0.5h-1zM3.5,-2.5h1v0.5h-1zM-6,-2h0.5v0.5h-0.5zM-4.5,-2h1v0.5h-1zM-3,-2h1.5v0.5h-1.5zM1,-2h3.5v1.5h-3.5zM-4.5,-1.5h2v1.5h-2zM-2,-1.5h0.5v0.5h-0.5zM5,-1.5h0.5v0.5h-0.5zM6,-1.5h0.5v0.5h-0.5zM-7,-1h1v1.5h-1zM-0.5,-1h1v0.5h-1zM6.5,-1h0.5v0.5h-0.5zM0,-0.5h4.5v0.5h-4.5zM6,-0.5h1v1h-1zM-5,0h1v0.5h-1zM-3,0h1v0.5h-1zM-0.5,0h5v0.5h-5zM-6,0.5h1.5v0.5h-1.5zM-3.5,0.5h5v0.5h-5zM3.5,0.5h1v0.5h-1zM5.5,0.5h0.5v0.5h-0.5zM-2.5,1h3v0.5h-3zM3,1h2v0.5h-2z',
    },
    {
      paint: 'tallGrass',
      d: 'M-3,-3h0.5v0.5h-0.5zM2.5,-2.5h1v0.5h-1zM-6.5,-2h0.5v1h-0.5zM-5.5,-2h0.5v0.5h-0.5zM-1.5,-2h1v1h-1zM0.5,-2h0.5v1h-0.5zM5,-2h0.5v0.5h-0.5zM-5.5,-1.5h1v0.5h-1zM-2.5,-1.5h0.5v0.5h-0.5zM4.5,-1.5h0.5v1h-0.5zM5.5,-1.5h0.5v0.5h-0.5zM-6,-1h1.5v1h-1.5zM-2.5,-1h2v0.5h-2zM5.5,-1h1v0.5h-1zM-2.5,-0.5h2.5v0.5h-2.5zM4.5,-0.5h1.5v1h-1.5zM-6,0h1v0.5h-1zM-2,0h1.5v0.5h-1.5zM4.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'leaf',
      d: 'M1,-4h0.5v1h-0.5zM0,-3.5h0.5v0.5h-0.5zM2,-3.5h0.5v0.5h-0.5zM4.5,-3.5h0.5v0.5h-0.5zM-4.5,-3h0.5v0.5h-0.5zM-2.5,-3h1.5v0.5h-1.5zM-0.5,-3h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5zM-4.5,-2.5h1v0.5h-1zM-1.5,-2.5h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM-5,-2h0.5v0.5h-0.5zM6,-2h0.5v0.5h-0.5zM-6,-1.5h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M-2.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5zM1.5,-3.5h0.5v1h-0.5zM-4,-3h1v0.5h-1zM-1,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM3.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1v0.5h-1zM-3.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'flower',
      d: 'M0.5,-6.5h1.5v0.5h-1.5zM-0.5,-6h3.5v0.5h-3.5zM-0.5,-5.5h4v0.5h-4zM0.5,-5h0.5v0.5h-0.5zM1.5,-5h1v0.5h-1zM0,-4.5h2v0.5h-2zM-6,-4h1v0.5h-1zM0,-4h1v0.5h-1zM1.5,-4h1v0.5h-1zM-6.5,-3.5h2v0.5h-2zM-6.5,-3h1v0.5h-1zM-5,-3h0.5v0.5h-0.5zM0,-3h0.5v0.5h-0.5zM-6.5,-2.5h2v0.5h-2zM-1,-2.5h2v0.5h-2zM-0.5,-2h0.5v0.5h-0.5zM-0.5,-1.5h1v0.5h-1z',
    },
    {
      paint: 'flowerCenter',
      d: 'M1,-5h0.5v0.5h-0.5zM-3.5,-4.5h0.5v0.5h-0.5zM-1,-4.5h0.5v0.5h-0.5zM-5.5,-3h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'wildflower',
      d: 'M-4,-5.5h1.5v0.5h-1.5zM3.5,-5.5h0.5v0.5h-0.5zM-5,-5h3v0.5h-3zM2.5,-5h2.5v0.5h-2.5zM-5,-4.5h1.5v0.5h-1.5zM-3,-4.5h1v0.5h-1zM2,-4.5h1.5v0.5h-1.5zM4,-4.5h1v1h-1zM-4.5,-4h2v1h-2zM2.5,-4h1v0.5h-1zM2.5,-3.5h2v0.5h-2z',
    },
    {
      paint: 'flowerAlt',
      d: 'M-1.5,-5.5h1v0.5h-1zM-2,-5h2.5v0.5h-2.5zM-2,-4.5h1v0.5h-1zM-0.5,-4.5h0.5v0.5h-0.5zM3.5,-4.5h0.5v1h-0.5zM-2,-4h2v1h-2zM5,-3.5h1v0.5h-1zM4,-3h2.5v0.5h-2.5zM4.5,-2.5h2v0.5h-2zM4.5,-2h0.5v0.5h-0.5zM5.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-4,0h1v0.5h-1zM-4.5,0.5h1v0.5h-1zM1.5,0.5h2v0.5h-2zM2.5,1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 331,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
